// extracted by mini-css-extract-plugin
export default {"navbar-light":"footer_navbar-light__pbxOd","navbar-toggler":"footer_navbar-toggler__IdN0f","navbar-toggler-icon":"footer_navbar-toggler-icon__6jb5o","footer":"footer_footer__OOu6o"};